import { apiProxyRequest } from "Api/apiProxyRequest";
import { encodeParameters } from "Api/utils";

import type { Activity } from "Api/activity/types";

type RunRuntimeOperationDeploymentRequestProps = {
  projectId: string;
  environmentId: string;
  deploymentId: string;
  operation: string;
  service: string;
};

export const runRuntimeOperationDeploymentRequest = ({
  projectId,
  environmentId,
  deploymentId,
  operation,
  service
}: RunRuntimeOperationDeploymentRequestProps) => {
  const {
    projectId: encodedProjectId,
    environmentId: encodedEnvironmentId,
    deploymentId: encodedDeploymentId
  } = encodeParameters({ projectId, environmentId, deploymentId });

  return apiProxyRequest<{
    code: number;
    status: string;
    _embedded: {
      activities: Activity[];
    };
  }>(
    `/projects/${encodedProjectId}/environments/${encodedEnvironmentId}/deployments/${encodedDeploymentId}/operations`,
    "POST",
    { operation, service }
  );
};
